// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"m1-z","displaySixCardTiles":"n1-z"};